module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-breadcrumb', [_c('b-breadcrumb-item', {
    attrs: {
      "text": "Home",
      "to": "/"
    }
  }), _vm._v(" "), _c('b-breadcrumb-item', {
    attrs: {
      "text": "Servers",
      "to": "/servers"
    }
  }), _vm._v(" "), _c('b-breadcrumb-item', {
    attrs: {
      "text": "New Server",
      "active": true
    }
  })], 1), _vm._v(" "), _c('b-container', [_c('b-row', [_c('b-col', [_c('b-form', {
    on: {
      "submit": _vm.addServer
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "lg": "6",
      "md": "6",
      "sm": "12",
      "xs": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "name-group",
      "label": "Name:",
      "label-for": "name",
      "description": "Enter the name of the server"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "name",
      "type": "text",
      "autofocus": "",
      "required": "",
      "placeholder": "Enter server name"
    },
    model: {
      value: (_vm.server.name),
      callback: function($$v) {
        _vm.$set(_vm.server, "name", $$v)
      },
      expression: "server.name"
    }
  })], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "lg": "6",
      "md": "6",
      "sm": "12",
      "xs": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "color-group",
      "label": "Color:",
      "label-for": "color",
      "description": "Color for display"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "color",
      "type": "color",
      "required": "",
      "placeholder": "Select color"
    },
    model: {
      value: (_vm.server.color),
      callback: function($$v) {
        _vm.$set(_vm.server, "color", $$v)
      },
      expression: "server.color"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "lg": "6",
      "md": "6",
      "sm": "12",
      "xs": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "hostname-group",
      "label": "Hostname:",
      "label-for": "hostname",
      "description": "Server Hostname or IP Address"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "hostname",
      "type": "text",
      "required": "",
      "placeholder": "Enter server hostname or IP address"
    },
    model: {
      value: (_vm.server.hostname),
      callback: function($$v) {
        _vm.$set(_vm.server, "hostname", $$v)
      },
      expression: "server.hostname"
    }
  })], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "lg": "6",
      "md": "6",
      "sm": "12",
      "xs": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "port-group",
      "label": "Port:",
      "label-for": "port",
      "description": "Server Port (default 4444)"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "port",
      "type": "text",
      "required": "",
      "placeholder": "Enter server port"
    },
    model: {
      value: (_vm.server.port),
      callback: function($$v) {
        _vm.$set(_vm.server, "port", $$v)
      },
      expression: "server.port"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "label": "Group:",
      "label-for": "name",
      "description": "Enter the server group"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "autofocus": "",
      "required": "",
      "placeholder": "Enter server group"
    },
    model: {
      value: (_vm.server.group),
      callback: function($$v) {
        _vm.$set(_vm.server, "group", $$v)
      },
      expression: "server.group"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "description-group",
      "label": "Description:",
      "label-for": "description",
      "description": "Server Description"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "id": "description",
      "type": "text",
      "placeholder": "Enter Description",
      "rows": "5"
    },
    model: {
      value: (_vm.server.description),
      callback: function($$v) {
        _vm.$set(_vm.server, "description", $$v)
      },
      expression: "server.description"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "d-flex justify-content-end"
  }, [_c('b-button-group', [_c('b-button', {
    attrs: {
      "type": "Submit",
      "variant": "primary"
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('b-button', {
    on: {
      "click": function($event) {
        return _vm.cancel()
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d3be985","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/servers/AddServerPage.vue
// module id = 2139
// module chunks = 1